import styled from "styled-components";
import { primaryBgColor, primaryFgColor, primaryFontColor } from "../Constant/constant";


export const FormLabel = styled.label`
    display: flex;
    flex-direction: row;
    line-height: 3;
    font-weight: 400;
`;

export const FormInput = styled.input`
    display: flex;
    flex-direction: row;
    background: ${primaryBgColor};
    color: white;
    border: 2px solid ${primaryFontColor};
    border-radius: 4px;
    padding: 12px;
    font-size: 24px;
    &:hover{
        border: 2px solid ${primaryFgColor};
        outline: none;
    }
    &:hover{
        outline:none;
    }
`;

export const ProjectTitle = styled.div`
    text-align:center;
    font-size:28px;
    font-weight:700;
    background:${'#01163c'};
    line-height: 2;
    position: relative;
    z-index: 4;
    margin-bottom:40px;
`;


export const TestimonialCardLayout = styled.div`
    margin: 13% auto;
    width: 64%;
    min-height: 220px;
    height: 228px;
    background: #DCDEE0;
    padding: 24px 0;
    border-radius: 20px;
`;
export const TestimonialImg = styled.div`
    width: 40%;
    float: left;
`;

export const TestimonialBody = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    width: 60%;
    float: left;
`;

export const HLButton = styled.div`
    padding: 12px;
    margin: 20px auto;
    border: 4px solid ${primaryFgColor};
    border-radius: 48px;
    width: 250px;
    text-align: center;
    background: ${primaryBgColor};
    color:${primaryFgColor};
    &:hover{
        background: ${primaryFgColor};
        color:${primaryBgColor};
        cursor:url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto;
    }
`;

export const HoverImage = styled.div`
    position: absolute;
    top: 72px;
    left: 20%;
    transform:${props => props.translate ? props.translate : 'translate(0,0)'}; ;
    z-index: ${props => props.zIndex ? props.zIndex : '1'};
    filter:brightness(0.5);
    transition:1s;
    &:hover{
        z-index:20;
        box-shadow: 2px 2px 17px 0px black;
        filter:none;
        cursor:url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto;
        transition:1s;
    }
`;

export const HoverText = styled.div`
    font-size: 32px;
    text-decoration: underline;
    text-underline-position: from-font;
    text-shadow: 12px 0px 20px black;
    position: absolute;
    top: 40%;
    left: -51px;
    z-index: 99;
    color: white;
    width: 200px;
`;

export const HighlightText = styled.span`
    color:${primaryFgColor};
    font-size:inherit;
`;

export const ScrollContainer = styled.div`
    position:absolute;
    top:${props => props.top ? props.top : '40px'};
    left:${props => props.left ? props.left : '10%'};
    width:10px;
    bottom:10px;
`;

export const ScrollIcon = styled.div`    
    position: absolute;
    top: 33px;
    padding-top:4px;
    transform: translateX(-10px);
    background: ${'#000c26'};
`;
export const ScrollText = styled.div`
    position: absolute;
    left: -65px;
    top: 200px;
    width: 110px;
    height: auto;
    transform: rotateZ(270deg);
    font-weight: bold;
`;
export const ScrollLine = styled.div`
    width:4px;
    height:100%;
    position:relative;
    top:${props => props.top ? props.top : '15px'};
    margin:auto;
    text-align:center;
    background:${primaryFgColor};
`;

export const FlexContainer = styled.div`
    min-height:100px;
    position:relative;
    overflow: hidden;
`;
export const FlexRowHeader = styled.div`
    height: 100px;
    basis:80%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
`;
export const FlexRow = styled.div`
    position: relative;
    min-height: 89vh;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    width: 80%;
    padding: 0 10%;
    justify-content: ${props => props.justify ? props.justify : 'center'};
    align-content: ${props => props.align ? props.align : 'center'};
    font-weight:bold;
`;

export const FloatingTitle = styled.div`
    filter:blur(1.5px);
    flex:1;
    flex-grow:0;
    flex-basis:100%;
    flex-direction: column;
    font-size: 12vw;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 0;
    left: 50%;
    top: 8%;
    transform: translateX(-50%);
    color: #979dac42;
    font-size: 64; 
    text-align: center;
`;

export const FlexCol = styled.div`
    flex:${props => props.size ? props.size : 1};
    flex-grow:${props => props.grow ? props.grow : 0};
    flex-basis:${props => props.basis ? props.basis : '100%'};
    flex-direction: column;
`;
export const SlickRow = styled.div`
    min-height: 80vh;
    width: 100%;
`;
export const SlickCard = styled.div`
    display: flex;
    flex-flow: column wrap;
    align-items: flex-end;
    min-height: 85vh;
    justify-content: center;
    padding: 0 12%;
    backdrop-filter: brightness(0.5);
`;
export const SlickItem = styled.div`
    font-size:${props => props.size};
    padding: 10px 0;
    color:white;
`;
export const SlickHeader = styled.div`
    font-size:${props => props.size};
    font-weight: 500;
    padding-top: 70px;
    color:white;
`;
export const SlickPara = styled.div`
    font-size:${props => props.size};
    max-width: 450px;
    text-align: right;
    color:white;
`;

export const Card = styled.div`
    margin: 15px 20%;
    padding: 30px;
    min-height: 16vh;
    box-shadow: 2px 5px 20px -3px #00000033;
    margin-bottom: 40px;
    border-radius: 10px;
`;

export const ServiceContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    width: 85%;
    margin: 0px auto;
    margin-top:120px;
`;

export const ServiceLink = styled.div`
    flex:1;
    flex-direction:column;
    min-height: 135px;
    min-width: 24%;
    max-width: 24%;
    padding: 24px 0;
    text-align: center;
    background:#686D76;
    // box-shadow: 0 4px 4px 0 #0000003d;
    margin-bottom:8px;
    cursor:url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto;
    border-radius: 6px;
    &:hover{
        box-shadow: 0 4px 4px 1px #00000060;
    }
`;

export const ServicesInfo = styled.div`
    display:flex;
    flex-flow:row wrap;
    width:100%;
    min-height: 40%;
    justify-content: flex-end;
    align-items: flex-start;
`;

export const ServiceInfoHead = styled.div`
    width:100%;
    font-size:3vw;
    font-weight:bold;
    text-align:center;
`;
export const Divider = styled.div`
    width:70%;
    border:2px solid #373A40;
    border-radius:20px;
    margin:30px auto;
    background: #373A40;
`;
export const ServiceInfoBody = styled.div`
    width:70%;
    margin:0 auto;
    font-size:1.2vw;
`;